import SvgIcon from '@mui/material/SvgIcon';

const CashOutIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path
      d="M7 15H4C3.73478 15 3.48043 14.8946 3.29289 14.7071C3.10536 14.5196 3 14.2652 3 14V6C3 5.73478 3.10536 5.48043 3.29289 5.29289C3.48043 5.10536 3.73478 5 4 5H16C16.2652 5 16.5196 5.10536 16.7071 5.29289C16.8946 5.48043 17 5.73478 17 6V9"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 19H8C7.73478 19 7.48043 18.8946 7.29289 18.7071C7.10536 18.5196 7 18.2652 7 18V10C7 9.73478 7.10536 9.48043 7.29289 9.29289C7.48043 9.10536 7.73478 9 8 9H20C20.2652 9 20.5196 9.10536 20.7071 9.29289C20.8946 9.48043 21 9.73478 21 10V12.5"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.9139 13.4169C15.8125 13.0845 15.6263 12.7844 15.3736 12.5459C15.1209 12.3074 14.8105 12.1389 14.4729 12.057C14.1352 11.975 13.7821 11.9824 13.4482 12.0784C13.1142 12.1744 12.8111 12.3558 12.5686 12.6046C12.3261 12.8535 12.1527 13.1612 12.0653 13.4975C11.9779 13.8337 11.9796 14.187 12.0703 14.5224C12.1609 14.8578 12.3374 15.1638 12.5823 15.4102C12.8272 15.6567 13.1321 15.8351 13.4669 15.9279M15.9999 18.9999H21.9999M15.9999 18.9999L18.9999 15.9999M15.9999 18.9999L18.9999 21.9999"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

export default CashOutIcon;
